import { render } from "./BasicLayout.vue?vue&type=template&id=79dfd982"
const script = {}

import "./BasicLayout.vue?vue&type=style&index=0&id=79dfd982&lang=css"

import exportComponent from "/Users/desarrollo/Documents/Proyectos/friax/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__